module.exports = __webpack_public_path__ + "img/qp58emwo36ma1.7ab69953.webp";